var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { altText, imgSrc, customClasses} = options; 
__p+='\n\n<div class="js-local-fsgallery-toggle '+
((__t=( customClasses ))==null?'':__t)+
'">\n  <div class="community-image community-image-'+
((__t=( index ))==null?'':__t)+
'">\n    ';
 if (typeof altText === 'string' && altText) { 
__p+='\n      <img class="img-responsive" data-src="'+
((__t=( imgSrc ))==null?'':__t)+
'" alt="'+
((__t=( altText ))==null?'':__t)+
'" title="'+
((__t=( altText ))==null?'':__t)+
'">\n    ';
 } else { 
__p+='\n      <img class="img-responsive" data-src="'+
((__t=( imgSrc ))==null?'':__t)+
'">\n    ';
 } 
__p+='\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./local/templates/communityTile.jst.ejs